module.exports = function() {
  return new Worker(__webpack_public_path__ + "b3eee93517d3ffde21d8.worker.js");
};